export enum TransferTypeEnum {
  Unknown = 0,
  Internal = 1,
  External = 2,
}

export const TransferTypeDisplayName = {
  [TransferTypeEnum.Unknown]: 'Unknown',
  [TransferTypeEnum.Internal]: 'Internal',
  [TransferTypeEnum.External]: 'External',
};
